<template>
    <!-- <div :class="`main-visual main-visual-${random}`" v-if="banner && ((pc && detect == 'pc') || (mobile && detect == 'mobile'))"> -->
    <div :class="`main-visual main-visual-${random}`" v-if="banner">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <!-- S::배너 -->
                <template v-for="(slide, index) in banner?.slides || []">
                    <div class="swiper-slide" :key="index">
                        <v-card :to="slide?.isOuterLink ? undefined : slide?.url" :href="slide?.isOuterLink ? slide?.url : undefined" :target="slide?.target" flat tile class="main-visual__inner">
                            <div class="main-visual__img" :style="'background-image:url(' + slide?.image + ');'"></div>
                        </v-card>
                    </div>
                </template>
                <!-- E::배너 -->
            </div>
            <div class="swiper-control">
                <button class="swiper-prev"><i class="icon icon-left-arrow-circle"></i></button>
                <button class="swiper-next"><i class="icon icon-right-arrow-circle"></i></button>
            </div>
        </div>
    </div>

    

    <!-- <div v-if="banner && ((pc && detect == 'pc') || (mobile && detect == 'mobile'))" class="main-visual swiper-container"> -->
    <!-- <div class="main-visual">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(slide, index) in banner?.slides || []" :key="index" class="swiper-slide">
                    <div class="main-visual__inner">
                        <div class="main-visual__img" :style="'background-image:url(' + slide?.image + ');'"></div>
                        <div class="main-visual__con">
                            <h3 class="main-visual__tit">{{ slide?.meta?.title }}</h3>
                            <div class="main-visual__info">
                                <ul>
                                    <li>{{ slide?.meta?.location }}</li>
                                    <li>{{ slide?.meta?.date?.toDate() }}</li>
                                </ul>
                            </div>
                            <v-btn v-if="slide?.url" :to="slide?.isOuterLink ? undefined : slide?.url" :href="slide?.isOuterLink ? slide?.url : undefined" :target="slide?.isOuterLink ? '_blank' : ''" small text color="white" class="main-visual__btn pa-4 ml-n4">VIEW MORE <i class="icon icon-bar white mt-2 ml-6"></i></v-btn>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-control">
                <div class="swiper-prev"><i class="icon icon-arrow-left"></i></div>
                <div class="swiper-pagination"></div>
                <div class="swiper-next"><i class="icon icon-arrow-right"></i></div>
            </div>
        </div>
    </div> -->
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";
import detect from "@/plugins/detect";

export default {
    props: {
        code: { type: String },

        pc: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false },
    },
    data: () => ({
        random: Math.random().toFixed(10).slice(2, 12),

        detect,
        banner: null,
        swiper: undefined,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { code } = this;
            let { banner } = await api.v1.banners.get({ code });
            this.banner = banner;

            this.$nextTick(() => {
                this.swiper = new Swiper(`.main-visual-${this.random} .swiper-container`, {
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 24,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    loopedSlides: 2,
                    navigation: {
                        nextEl: ".main-visual .swiper-next",
                        prevEl: ".main-visual .swiper-prev",
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
// main-visual
.main-visual {
    width: 100%;
    .swiper-container {
        overflow: visible;
    }
}
.main-visual__inner {
    position: relative;
    display: block;
    width: 100%;
    height: 0;
    padding-top: calc(480 / 720 * 100%);
}
.main-visual__img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .main-visual__inner {
        padding-top: calc(480 / 1380 * 100%);
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
